import { render, staticRenderFns } from "./Simple-button.vue?vue&type=template&id=c7275748&scoped=true"
import script from "./Simple-button.vue?vue&type=script&lang=js"
export * from "./Simple-button.vue?vue&type=script&lang=js"
import style0 from "./Simple-button.vue?vue&type=style&index=0&id=c7275748&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7275748",
  null
  
)

export default component.exports